import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import React, { PropsWithChildren } from 'react';
import { clsx } from 'clsx';
import { Row } from '@design-system/components/grid/grid';
import { Button, ButtonProps } from '@design-system/components/button/button';

export const Desc = (p: PropsWithChildren<{ className?: string }>) => (
  <Typography
    variant="body"
    size="medium"
    fontWeight="medium"
    style={{ fontWeight: 400 }}
  >
    {p.children}
  </Typography>
);

export const Hint = (p: PropsWithChildren<{ className?: string }>) => (
  <Typography
    variant="body"
    size="medium"
    className={clsx(
      sprinkles({ color: 'N-60', py: 's', fontWeight: 'normal' }),
      p.className,
    )}
  >
    {p.children}
  </Typography>
);

export const Hint2 = (p: PropsWithChildren<{ className?: string }>) => (
  <Typography
    variant="body"
    size="medium"
    className={clsx(sprinkles({ color: 'N-60', py: 's' }), p.className)}
    fontWeight="normal"
  >
    {p.children}
  </Typography>
);

export const TitleRow = (p: {
  title: string;
  button?: ButtonProps;
  rightContent?: React.ReactElement;
}) => (
  <Row
    style={{
      width: '100%',
      flex: 1,
      alignItems: 'center',
      justifyContent: 'space-between',
    }}
  >
    <Typography variant="headline" size="small" style={{ fontWeight: 'bold' }}>
      {p.title}
    </Typography>
    {p.rightContent ? p.rightContent : null}
    {p.button ? <Button {...p.button} /> : null}
  </Row>
);

export const Price = ({ value }: { value: [number, number] | null }) => {
  if (!value) return null;
  return (
    <>
      {'$' + value[0] + '.' + (value[1] < 10 ? '0' + value[1] : value[1] % 100)}
    </>
  );
};

export const PriceRow = (p: {
  price: [number, number] | null;
  discountedPrice: [number, number] | null;
}) => {
  if (p.price === null) return <></>;
  return (
    <Row>
      <Desc>
        Price:{' '}
        <b>
          <Price
            value={p.discountedPrice === null ? p.price : p.discountedPrice}
          />
        </b>{' '}
        <span style={{ textDecoration: 'line-through', opacity: 0.4 }}>
          <Price value={p.discountedPrice === null ? null : p.price} />
        </span>
      </Desc>
    </Row>
  );
};
